import useAuth from 'hooks/useAuth';
import { useParams } from 'react-router-dom';
import DateColumn from '../sistema/dateColumn';
import VendaCaixa from './graficos/vendaCaixa';
import BackButton from '../sistema/backButton';
import baseController from 'api/base.controller';
import ResumoEvento from './graficos/resumoEvento';
import React, { useState, useEffect } from 'react';
import ReloadButton from '../sistema/reloadButton';
import ResumoProduto from './graficos/resumoProduto';
import Error401 from 'components/pages/errors/Error401';
import FullScreenLoading from '../sistema/fullScreenLoading';
import VendaPorHoraEvento from './graficos/vendaPorHoraEvento';
import { Row, Col, Card, Form, Button } from 'react-bootstrap';
import VendaFormaPagamento from './graficos/vendaFormaPagamento';
import FieldValidationMessage from '../sistema/fieldValidationMessage';
import { lojaDashboradRole } from 'components/pages/sistema/allowedRoles';

const ClienteDashboard = () => {
  const { auth } = useAuth();
  const { idEvento, idLoja } = useParams();
  const [lojaNome, setLojaNome] = useState('');
  const [eventoInfo, setEventoInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [vendaHoraData, setVendaHoraData] = useState([]);
  const [vendaCaixaData, setVendaCaixaData] = useState([]);
  const [resumoEventoData, setResumoEventoData] = useState([]);
  const [resumoProdutoData, setResumoProdutoData] = useState([]);
  const [formaPagamentoData, setFormaPagamentoData] = useState([]);

  const [todayActive, setTodayActive] = useState(false);
  const [last15Active, setLast15Active] = useState(false);
  const [last30Active, setLast30Active] = useState(false);
  const [yesterdayActive, setYesterdayActive] = useState(false);
  const [wholePeriodActive, setWholePeriodActive] = useState(true);
  const [customPeriodActive, setCustomPeriodActive] = useState(false);

  const [finalDate, setFinalDate] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [filterChanged, setFilterChanged] = useState(false);

  const handleDateFilter = (period) => {
    const definePeriod = (period, subtractFinal = 0) => {
      const final = new Date();
      const initial = new Date();

      initial.setDate(initial.getDate() - period);
      initial.setHours(0, 0, 0, 0);

      setInitialDate(initial);

      final.setDate(final.getDate() - subtractFinal);
      final.setHours(23, 59, 59, 999);

      setFinalDate(final);
    }

    switch(period) {
      case 'today': {
        definePeriod(0);
        break;
      }
      case 'yesterday': {
        definePeriod(1, 1)
        break;
      }
      case 'last15': {
        definePeriod(15);
        break;
      }
      case 'last30': {
        definePeriod(30);
        break;
      }
      default: {
        setFinalDate(null);
        setInitialDate(null);
      }
    }

    setFilterChanged(true);
  };

  const loadData = async () => {
    setIsLoading(true);

    const params = {
      dataFinal: finalDate,
      dataInicial: initialDate
    };

    doLoadData(params);
  };

  const handleLoadDataCustomFilter = () => {
    setIsLoading(true);

    const adjustedFinalDate = new Date(finalDate);

    adjustedFinalDate.setDate(adjustedFinalDate.getDate() + 1);
    adjustedFinalDate.setHours(23, 59, 59);

    const params = {
      dataFinal: adjustedFinalDate,
      dataInicial: initialDate
    }

    doLoadData(params);
  };

  const doLoadData = async (params) => {
    const headers = {
      Authorization: auth.token ?? JSON.parse(localStorage.getItem('auth')).token
    };

    const resEventoInfos = await baseController.get(`Dashboard/GetSpecificEventoInfo/${idEvento}`, { params, headers });
    const resResumoEvento = await baseController.get(`Dashboard/ResumoEvento/${idEvento}/${idLoja}`, { params, headers });
    const resVendaHoraData = await baseController.get(`Dashboard/VendaHoraEvento/${idEvento}/${idLoja}`, { params, headers });
    const resVendaCaixaData = await baseController.get(`Dashboard/VendaCaixaEvento/${idEvento}/${idLoja}`, { params, headers });
    baseController.get(`Dashboard/ResumoProdutoEvento/${idEvento}/${idLoja}`, { params, headers }).then((res) => {
      if(res.data?.length > 0)
        setLojaNome(res.data[0].lojas[0].nome);
      
      setResumoProdutoData(res.data);
    });
    const resFormaPagamento = await baseController.get(`Dashboard/FormaPagamentoEvento/${idEvento}/${idLoja}`, { params, headers });
    
    setEventoInfo(resEventoInfos.data);
    setVendaHoraData(resVendaHoraData.data);
    setVendaCaixaData(resVendaCaixaData.data);
    setResumoEventoData(resResumoEvento.data);
    setFormaPagamentoData(resFormaPagamento.data);

    setIsLoading(false);
    setFilterChanged(false);
  };

  useEffect(() => {
    if(filterChanged) loadData();
  }, [filterChanged]);

  useEffect(async () => {
    const isAuthorized = lojaDashboradRole.includes(auth.role ?? JSON.parse(localStorage.getItem('auth')).role);

    setAuthorized(isAuthorized);
    
    if (isAuthorized) loadData();
  }, []);

  if(isLoading) return (<FullScreenLoading />);

  if(!authorized) return (<Error401 />);

  const dashboard = (showButtons) => (
    <Card className='dashboard-card'>
      { showButtons ? 
        <Card.Header>
          <h1 className='dashboard-title'>
          {eventoInfo.isClienteMensal ? eventoInfo.nome : eventoInfo.nome + ' - ' + eventoInfo.local + ' - ' + lojaNome}
          </h1>
          <div className='fw-600 flex-row align-center event-period-wrapper'>
            <DateColumn date={eventoInfo.dataInicio}/>
            <p className='date-spacer'>-</p>
            <DateColumn date={eventoInfo.dataTermino}/>
          </div>
          <Row className='grid-actions'>
            <BackButton />
            <ReloadButton getData={loadData}/>
          </Row>
          <Row className='grid-actions dashboard-filter-actions'>
            <Button 
              className='button-date-filter d-inline-block text-truncate' 
              variant={todayActive ? 'success' : 'primary'}
              onClick={() => {
                setTodayActive(true);
                setLast15Active(false);
                setLast30Active(false);
                setYesterdayActive(false);
                setWholePeriodActive(false);
                setCustomPeriodActive(false);

                handleDateFilter('today');
              }}
            >Hoje</Button>

            <Button 
              className='button-date-filter'
              variant={yesterdayActive ? 'success' : 'primary'}
              onClick={() => {
                setTodayActive(false);
                setLast15Active(false);
                setLast30Active(false);
                setYesterdayActive(true);
                setWholePeriodActive(false);
                setCustomPeriodActive(false);

                handleDateFilter('yesterday');
              }}
            >Ontem</Button>

            <Button 
              className='button-date-filter'
              variant={last15Active ? 'success' : 'primary'}
              onClick={() => {
                setTodayActive(false);
                setLast15Active(true);
                setLast30Active(false);
                setYesterdayActive(false);
                setWholePeriodActive(false);
                setCustomPeriodActive(false);

                handleDateFilter('last15');
              }}
            >15 Dias</Button>

            <Button 
              className='button-date-filter'
              variant={last30Active ? 'success' : 'primary'}
              onClick={() => {
                setTodayActive(false);
                setLast15Active(false);
                setLast30Active(true);
                setYesterdayActive(false);
                setWholePeriodActive(false);
                setCustomPeriodActive(false);

                handleDateFilter('last30');
              }}
            >30 Dias</Button>

            <Button 
              className='button-date-filter long'
              variant={wholePeriodActive ? 'success' : 'primary'}
              onClick={() => {
                setTodayActive(false);
                setLast15Active(false);
                setLast30Active(false);
                setYesterdayActive(false);
                setWholePeriodActive(true);
                setCustomPeriodActive(false);

                handleDateFilter('wholePeriod');
              }}
            >Todo o Período</Button>
          </Row>
          <Row>
            <Form onSubmit={handleLoadDataCustomFilter}>
              <Row className='custom-date-filter-row'>
                <Col>
                  <Form.Group controlId="formGroupDataInicio">
                    <Form.Control
                      required
                      name="dataInicio"
                      type="date"
                      value={initialDate}
                      selected={initialDate}
                      placeholder="Data de Início do Evento"
                      onChange={(e) => setInitialDate(e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      <FieldValidationMessage fieldName="Data de Início" />
                    </Form.Control.Feedback>
                  </ Form.Group>
                  <Form.Label>Data Inicial</Form.Label>
                </Col>
                <Col>
                  <Form.Group controlId="formGroupDataTermino">
                    <Form.Control
                      required
                      name="dataTermino"
                      type="date"
                      value={finalDate}
                      selected={finalDate}
                      onChange={(e) => setFinalDate(e.target.value)}
                      placeholder="Data de Encerramento do Evento"
                      isInvalid={new Date(finalDate).getTime() < new Date(initialDate).getTime()}
                    />
                    <Form.Control.Feedback type="invalid">
                      <FieldValidationMessage 
                        greaterThan
                        fieldName="Data de Encerramento"
                        fieldGreaterThan="Data de Início"
                      />
                    </Form.Control.Feedback>
                    <Form.Label>Data Final</Form.Label>
                  </ Form.Group>
                </Col>
                <Col>
                  <Button type="submit"
                    variant={customPeriodActive ? 'success' : 'primary'}
                    onClick={() => { 
                      setTodayActive(false);
                      setLast15Active(false);
                      setLast30Active(false);
                      setYesterdayActive(false);
                      setWholePeriodActive(false);
                      setCustomPeriodActive(true);
                    }}>Filtrar</Button>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card.Header> : <></>
      }
      <Row className="g-1 mb-1">
        <Col className="dashboard-resumo" md={12} xxl={3}>
          <ResumoEvento data={resumoEventoData} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6}>
          <VendaFormaPagamento data={formaPagamentoData} radius={['70%', '100%']} />
        </Col>
        <Col lg={6}>
          <ResumoProduto data={resumoProdutoData} showDetails={false} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={12}>
          <VendaPorHoraEvento data={vendaHoraData}/>
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6}>
          <VendaCaixa data={vendaCaixaData} />
        </Col>
      </Row>
    </Card>
  );

  return dashboard(true);
};

export default ClienteDashboard;